import HeroHomePrestataire from "../../components/HeroHomePrestataire";
import ListMainServices from "../../components/ListMainServices";
import { PartnersSection} from "../../components/ReferralCards";

export default function EspacePrestataire(){
    return(
        <main>
            <HeroHomePrestataire/>
            <ListMainServices />
            <PartnersSection />
        </main>
    )
} 